/* ⚛ REACT */
import {useState} from "react";

/* 🎨 STYLES */
import { Container, SideBarButton, Circle, Line} from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

const SideBarSubItem = (props) => {
    const Itens = isValidaProp(props.itens) ? props.itens : []
    const [hovered, setHovered] = useState(false);

    const changePage = (e, func)=>{
        e.preventDefault()
        func.locationFunction();
    }

    return(
        <Container>
            {Itens.map((item, index) =>{
                return(
                    <SideBarButton 
                        href={item.page}
                        onMouseEnter={() => setHovered(index)} 
                        onMouseLeave={() => setHovered(null)}
                        key={index} 
                        onClick={(e)=>{changePage(e, item)}}>

                        <Circle $isHovered={hovered === index}/>

                        <Line/>
                        
                        {item.text}
                    </SideBarButton>
                )
            })}
        </Container>
    )
}

export default SideBarSubItem;